import { ContentType } from '@entries/content-types'
import ContentfulSeo from '@entries/contentful-seo'
import { withDisplayName } from '@hocs/with-display-name'
import { SEO_IDS } from '@meta/constants'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulDeprecatedPageSeo: Utils.EntryFC<
  Queries.ContentfulDeprecatedPageSeoFragment
> = ({ content: { seoRef } }) => (
  <>
    <meta content="website" property="og:type" />
    <meta content="summary" id={SEO_IDS.TWITTER_CARD} property="twitter:card" />
    <Entry
      content={seoRef}
      mapping={{
        [ContentType.ContentfulSeo]: ContentfulSeo,
      }}
    />
  </>
)

export const query = graphql`
  fragment ContentfulDeprecatedPageSeo on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    seoRef {
      ...ContentfulSeo
    }
  }
`

export default withDisplayName(
  ContentfulDeprecatedPageSeo,
  'ContentfulDeprecatedPageSeo'
)
